module.exports = __webpack_public_path__ + "img/icon-paypal.12c7c4aa.svg";